import { SearchBar } from '../../../SearchBar/SearchBar'

import AddNewTab from './AddNewTab/AddNewTab'
import ChangeTabTab from './ChangeTabTab/ChangeTabTab'
import NLUFilters from './NLUFilters/NLUFilters'

import styles from './examples-heading.module.scss'

export enum examplesHeadingTabEnum {
    SEARCH = 'SEARCH',
    ADD = 'ADD',
    FILTERS = 'FILTERS',
}

interface IExamplesHeadingProps {
    search: string
    setSearch: React.Dispatch<React.SetStateAction<string>>
}

function ExamplesHeading(props: IExamplesHeadingProps) {
    const { search, setSearch } = props

    return (
        <div className={styles.examplesHeading}>
            <SearchBar value={search} onChange={setSearch} />
            <NLUFilters />
            <ChangeTabTab />
            <AddNewTab />
        </div>
    )
}

export default ExamplesHeading
